import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'

import { IsAuthorized } from 'src/authentication/IsAuthorized'
import { ProductTypeOutputDTO } from 'src/services/reservation/product-type/productTypeDTO'

class ProductTypeServices {
  async getByParam(params: object): Promise<ProductTypeOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/product-type/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByParamByUser(): Promise<ProductTypeOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/product-type/by-user/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const productTypeServices = new ProductTypeServices()
